import { Alert } from "@cmsgov/ds-medicare-gov";
import { FormattedMessage } from "react-intl";
import URI from "urijs";
import { Link, useLocation } from "react-router-dom";
import { useCurrentPlanYear } from "../helpers/yearFlagHelpers";
import { useAppContext } from "../helpers/context-hooks/useAppContext";
import { useMgovRedesignClass } from "../helpers/flag-hooks/useMgovRedesignClass";
import type { FC } from "react";

export const YearSwitchBanner: FC = () => {
  const location = useLocation();
  const mctCurrentPlanYear = useCurrentPlanYear();
  const mgovRedesignClass = useMgovRedesignClass();
  const { state } = useAppContext();
  const isCurrentYear = state.year === mctCurrentPlanYear.toString();
  const otherYear = isCurrentYear ? mctCurrentPlanYear + 1 : mctCurrentPlanYear;

  const switchYearRoute = new URI(location.search);
  switchYearRoute.removeSearch("year");
  switchYearRoute.addSearch({ year: otherYear });

  return (
    <div className={mgovRedesignClass}>
      <Alert
        role="alert"
        className="previewBanner mct-hide-print"
        data-testid="e2e-year-switch-banner"
      >
        <span>
          <FormattedMessage
            id="public_preview.viewing_year_plans"
            values={{ year: state.year }}
          />{" "}
          <Link to={switchYearRoute.valueOf()}>
            <FormattedMessage
              id="public_preview.show_me_year_plans"
              values={{ year: otherYear }}
            />
          </Link>
        </span>
      </Alert>
    </div>
  );
};
